module.exports = __webpack_public_path__ + "media/images/landing_pages/hot_compulsory_insurance-8335c594dc9dd162aa6d47f81e74db86.svg";